export const VACATION_REQUEST = '/vacation-request/' as const
export const VACATION_REQUEST_DOWNLOAD = `${VACATION_REQUEST}download` as const
export const VACATION_REQUEST_STATUS = `${VACATION_REQUEST}status` as const
export const VACATION_PUBLIC_INFO = '/public/vacation-request' as const
